/**
 * useZoom
 * Resolves the effective zoom scale.  Accepts an explicit float from the
 * parent (`zoomScale` prop, used by Fit Page / Full Width) and falls back
 * to a stepwise scale derived from the integer `zoom` prop.
 */
export default function useZoom(zoomScaleProp, zoom) {
  if (typeof zoomScaleProp === "number" && zoomScaleProp > 0) return zoomScaleProp;
  switch (zoom) {
    case 1: return 1;
    case 2: return 1.25;
    case 3: return 1.5;
    case 4: return 1.75;
    default: return 2;
  }
}
